import { render, staticRenderFns } from "./BillingCardBasicPriceBox.vue?vue&type=template&id=12cebfb0&scoped=true&lang=pug"
import script from "./BillingCardBasicPriceBox.vue?vue&type=script&lang=js"
export * from "./BillingCardBasicPriceBox.vue?vue&type=script&lang=js"
import style0 from "./BillingCardBasicPriceBox.vue?vue&type=style&index=0&id=12cebfb0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cebfb0",
  null
  
)

export default component.exports